<template>
  <div>
    <div
      style="
        margin: 0 auto;
        max-width: 1000px;
        border-radius: 3px;
        padding-top: 50px;
        padding: 20px;
        height: 100%;
        min-height: calc(100vh - 50px);
      "
    >
      <a-card>
        <a-skeleton active :loading="loadingMe">
          <a-row :gutter="[8, 8]" style="margin: 0;">
            <a-col :sm="24" :md="24">
              <a-col :sm="24" :md="24">
                <a-card style="border: 0;">
                  <InfoEmployee :employee="employee" />
                </a-card>
              </a-col>
              <a-col :sm="24" :md="24">
                <a-card style="border: 0;">
                  <LeaveDayDetail :employee="employee" />
                </a-card>
              </a-col>
              <a-col :sm="24" :md="24" style="text-align: right;">
                <a-button icon="double-left" type="primary" @click="goToBack">
                  Go back
                </a-button>
              </a-col>
            </a-col>
          </a-row>
        </a-skeleton>
      </a-card>
    </div>
  </div>
</template>
<script>
import query from "./constants/query";

// components
import InfoEmployee from "./components/InfoEmployee";
import LeaveDayDetail from "./components/LeaveDayDetail";

export default {
  components: {
    InfoEmployee,
    LeaveDayDetail,
  },
  data() {
    return {
      loadingMe: false,
      me: {},
    };
  },
  computed: {
    employee() {
      return this.me?.employee ? { ...this.me.employee } : {};
    },
  },
  mounted() {
    this.onGetMe();
  },
  methods: {
    onGetMe() {
      this.loadingMe = true;
      this.$apollo
        .query({
          query: query.me,
        })
        .then(({ data }) => {
          if (data?.me?.id) {
            this.me = { ...data.me };
          }
          this.loadingMe = false;
        })
        .catch((err) => {
          this.loadingMe = false;
          console.error("Cannot get query me", err);
        });
    },
    goToBack() {
      this.$router.go("-1");
    },
  },
};
</script>
<style lang="css" scoped>
.top-card-p-6 >>> .ant-card-body {
  padding: 6px !important;
}
</style>
